import Script from 'next/script'
import { TRACKING_CONFIG } from '@/config/tracking.config'

export const GoogleAnalytics = () => (
  <>
    {/* Google Analytics */}
    <Script async src={`https://www.googletagmanager.com/gtag/js?id=${TRACKING_CONFIG.googleAnalytics.id}`} />
    
    {/* Google Tag Manager */}
    <Script
      id="gtag-manager"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${TRACKING_CONFIG.googleAnalytics.gtmId}');`,
      }}
    />
  </>
) 